import * as shvl from 'shvl';
import Vue from 'vue';

import {
  setI18NLocale,
  i18n,
  FALLBACK_LOCALE,
  loadI18NLocaleMessage,
} from '../plugins/i18n';
import { i18n as i18nConfig } from '@xd-rocket/attributes/src/attributes/screen';

import RocketHttpAssets, { getRocketHttpAssets } from '~/libs/http-assets';
import { checkLimit, imagePreload } from '~/libs/moo';
import { customMerge } from '@xd-rocket/utils/base';

const $bus = new Vue();
// const ENV = process.env;
const state = () => ({
  id: '',
  code: '',
  game: {},
  pureInfo: {},
  pureNodes: {},
  // tree: [],
  pathNeedWatch: [], // 事件编辑器执行更新的数据池路径，需要在节点中监听
  head: {},
  minify: {
    blockLyJs: '',
    globalHtml: '',
    globalJs: '',
  },
  codeMatch: {
    isHasGameLauncher: false, // 是否用到启动器
    isHasMediaShare: false, // 是否用到媒体分享
  }, // globalJs、blockLyJs 中匹配出来的关键信息
  widgetResource: {
    css: [],
    script: [],
  },
  // os: {}, // 系统信息
  device: '', // 设备类型 ios / android / other
  request: {}, // 请求 Get 参数
  isNeedAutoAdaptive: false,
  // nodesStr: '',
});

const getters = {
  getLocaleMessage: () => (key) => i18n.t(key),
  on: () => (event, cb) => {
    $bus.$on(event, cb);
  },
  once: () => (event, cb) => {
    $bus.$once(event, cb);
  },
  off: () => (event, cb) => {
    $bus.$off(event, cb);
  },
  emit:
    () =>
    (eventName, ...args) => {
      $bus.$emit(eventName, ...args);
    },
  $bus: (_, getters) => {
    // getter 中的 $on 被劫持修改，命名为 on
    return {
      $on: getters.on,
      $once: getters.once,
      $off: getters.off,
      $emit: getters.emit,
      _events: $bus._events,
      callback: {
        getLocaleMessage: getters.getLocaleMessage,
        checkLimit,
      },
    };
  },
};

const mutations = {
  setPageJson(state, data) {
    Object.assign(state, data);
  },
  setNodes(state, data) {
    state.nodesStr = data;
  },
  setRequest(state, data) {
    state.request = data;
  },
  setDevice(state, data) {
    state.device = data;
  },
  cleanStoreMinify(state, key) {
    state.minify[key] = '';
  },
};

const actions = {
  initEvent({ getters, dispatch }) {
    getters.on('rocket:system:updateLocale', (payload) => {
      dispatch('updateLocale', payload);
    });
    getters.on('rocket:system:updateLocaleMessage', (key, value) => {
      dispatch('updateLocaleMessage', { key, value });
    });

    getters.on(
      'rocket:api:requestAPI',
      (
        name,
        type,
        api,
        headers = {},
        params = {},
        isTapTap = false,
        responseType = 'json'
      ) => {
        dispatch('initRequest', {
          name,
          type,
          api,
          headers,
          params,
          isTapTap,
          responseType,
        });
      }
    );
    getters.on('rocket:image:preload', imagePreload);
  },
  updateLocale({ state, getters }, payload) {
    if (!payload) return;
    let sourceData = shvl.get(state, ['pureInfo', 'i18n'], {});
    if (sourceData[payload] === undefined) payload = FALLBACK_LOCALE;
    if (i18n.locale === payload) return;

    let result = shvl.get(sourceData, payload, {});
    if (payload !== FALLBACK_LOCALE) {
      let _default = shvl.get(sourceData, FALLBACK_LOCALE, {});
      result = customMerge({}, _default, result);
    }
    i18n.setLocaleMessage(payload, result);
    setI18NLocale(payload);
    getters.emit('rocket:system:after-update-locale', payload);
  },
  updateLocaleMessage({ getters }, { key, value } = {}) {
    let locale = i18n.locale;
    let messages = i18n.getLocaleMessage(locale);
    shvl.set(messages, key, value);
    i18n.setLocaleMessage(locale, messages);
    if (key.join) key = key.join('.');
    getters.emit('rocket:system:after-update-i18n:' + key);
  },

  loadI18N({ state, dispatch }) {
    loadI18NLocaleMessage(state.pureInfo?.i18n);
    dispatch('updateLocale');
    i18nConfig.init(i18n);

    // let attr = getAttribute('i18n');
    // attr.init(i18n);
  },

  storeInit({ dispatch }) {
    dispatch('loadI18N');
    dispatch('initEvent');
  },
  async nuxtServerInit({ state, commit }, { params, $http }) {
    const code = params['preview'] || params['code'];
    if (!code || code === '') {
      throw new Error('没有获取页面编号');
    }
    const isPreview = params['preview'];
    const url = process.env.NUXT_ENV_API + '/api/v3.0/page-json/' + code;
    const res = await $http.$get(url);
    if (!res.data_compiled?.pureInfo || !res.minify.nodeStyle) {
      let tip =
        '页面在服务器编译中遇到故障，请前往编辑器更新并保存，故障会在保存时弹窗说明。';
      console.error(tip);
      throw new Error(tip);
    }
    let widgetResourceLists = {
      WidgetCarousel: {
        css: [
          {
            href: process.env.NUXT_CDN + '/_system/style/swiper-moo-5.4.2-20250109.css',
            rel: 'stylesheet',
          },
        ],
        script: [
          // {
          //   src: process.env.NUXT_CDN + '/_system/js/swiper-5.4.2.js',
          //   defer: true,
          // },
        ],
      },
    };

    let widgetResource = {
      css: [],
      script: [],
    };
    for (let widgetType in res.data.structure) {
      if (widgetType === 'WidgetCarousel') {
        widgetResource.css.push(...widgetResourceLists[widgetType].css);
        widgetResource.script.push(...widgetResourceLists[widgetType].script);
      }
    }
    // console.log(res.data_compiled);
    res.data_compiled.pureInfo.i18n = res.info.i18n;
    if (!isPreview) {
      res.minify.nodeStyle = 'ALL-STYLE';
      res.minify.globalStyle = '';
    }
    // console.log(res.minify);
    commit('setPageJson', {
      code: res.code,
      game: res.game,
      pureInfo: res.data_compiled.pureInfo,
      pureNodes: res.data_compiled.pureNodes,
      pathNeedWatch: res.data_compiled.pathNeedWatch,
      head: res.data_compiled.head,
      minify: res.minify,
      codeMatch: res.data_compiled.codeMatch,
      widgetResource,
      // styles: res.data_compiled.styles,
      // styles
    });
    // let data = initTree(res);
    // commit('setPageJson', data);
    // let nodes = initNodes(data.pureNodes, data.pureInfo);
    // // 查询所有页面并将他们的高度设置为适应内容，因为高度 100% 会导致窗口滚动条与内容滚动条同时存在的问题，如果是 onePage 可以在轮播图上设置。
    // nodes[data.pureInfo.screenId].children.forEach((id) => {
    //   nodes[id].constraint.h = 'fit';
    // });
    // commit('setNodes', JSON.stringify(nodes));
  },
  async initRequest({ state, getters }, payload) {
    let { name, type, api, headers, params, isTapTap, responseType } = payload;
    let who = isTapTap ? 'taptap' : 'default';

    getters.emit('rocket:api:request-before:' + name);
    const httpType = getRocketHttpAssets(who);
    try {
      let res = '';
      const config = {
        headers,
        responseType,
      };
      if (type === 'GET') {
        config.params = params;
        if ($bus._events['rocket:api:request-progress:' + name]) {
          config.onDownloadProgress = (e) => {
            let percent = (e.loaded / e.total) * 100;
            if (isNaN(percent)) percent = 0;
            else percent = Math.min(100, Math.max(0, Math.round(percent)));
            getters.emit('rocket:api:request-progress:' + name, percent);
          };
        }
        res = await httpType.get(api, config);
      } else if (type === 'POST') {
        params._timestamp = new Date().getTime();
        res = await httpType.post(api, params, config);
      }

      let data = res,
        status = 200;
      if (httpType === RocketHttpAssets.axios) {
        data = res.data;
        status = res.status;
      }
      getters.emit('rocket:api:request-success:' + name, status, data);
    } catch (error) {
      if (error.response) {
        getters.emit(
          'rocket:api:request-error:' + name,
          error.response.status,
          error.response.data
        );
      } else {
        getters.emit(
          'rocket:api:request-error:' + name,
          error.name,
          error.message
        );
      }
    }
    getters.emit('rocket:api:request-after:' + name);
  },
};

export const strict = false;

export { getters, actions, mutations, state };
